var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"no-player-banner",attrs:{"src":require('@/assets/img/no-player-banner.jpg'),"alt":"No Player Banner"}})}
var staticRenderFns = []

export { render, staticRenderFns }